import { render, staticRenderFns } from "./traceability.vue?vue&type=template&id=61e0269e&scoped=true&"
import script from "./traceability.vue?vue&type=script&lang=js&"
export * from "./traceability.vue?vue&type=script&lang=js&"
import style0 from "./traceability.vue?vue&type=style&index=0&id=61e0269e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e0269e",
  null
  
)

export default component.exports